
export const SAVE_COMERCIAL_DATA_REQUEST = "comercialDataForm/SAVE_COMERCIAL_DATA_REQUEST";
export const SAVE_COMERCIAL_DATA_SUCCESS = "comercialDataForm/SAVE_COMERCIAL_DATA_SUCCESS";
export const SAVE_COMERCIAL_DATA_FAILED = "comercialDataForm/SAVE_COMERCIAL_DATA_FAILED";
